<template>
  <div class="ca-banner__footer-left min-w-0">
    <slot name="left" />
  </div>

  <CarouselControls
    v-if="showControls && slideCount > 1"
    class="ca-banner__controls"
    :class="{ 'ca-banner__controls--hide-mobile': !showControlsMobile }"
    :slide-count="slideCount"
    :active-slide="activeSlide"
    :is-playing="isPlaying"
    :dot-progress="dotProgress"
    @toggle-play="$emit('toggle-play')"
    @go-to-slide="$emit('go-to-slide', $event)"
  />

  <div class="ca-banner__footer-right min-w-0 justify-end">
    <slot name="right" />
  </div>
</template>

<script setup>
import CarouselControls from "../../base/CarouselControls.vue";
import { IconButton } from "ca-online-design-system";
import MouseScrollIcon from "../../../assets/mouse_scroll.svg";

defineOptions({ name: "BannerFooter" });

defineProps({
  slideCount: {
    type: Number,
    default: 1,
  },
  activeSlide: {
    type: Number,
    default: 0,
  },
  showControls: {
    type: Boolean,
    default: true,
  },
  showControlsMobile: {
    type: Boolean,
    default: true,
  },
  isPlaying: {
    type: Boolean,
    default: true,
  },
  dotProgress: {
    type: Number,
    default: 0,
  },
  showCounter: {
    type: Boolean,
    default: true,
  },
});

defineEmits(["toggle-play", "go-to-slide", "scroll-next"]);
</script>

<style scoped lang="scss">
.ca-banner__footer-left {
  flex: 1;
}

.ca-banner__footer-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 767px) {
  .ca-banner__footer-left {
    order: 2;
    flex: none;
  }

  .ca-banner__controls {
    order: 1;
    flex: none;
  }

  .ca-banner__publicidade {
    display: block;
  }

  .ca-banner__scroll-icon {
    display: none;
  }

  .ca-banner__footer-right {
    order: 3;
    flex: none;
  }

  .ca-banner__controls--hide-mobile {
    display: none;
  }
}
</style>
